import {Component, Input, OnInit} from '@angular/core';
import {LangService} from "../../services/lang.service";
@Component({
    selector: 'app-lang',
    templateUrl: './translation.component.html',
    styleUrls: ['./translation.component.scss'],
    standalone: false
})
export class TranslationComponent implements OnInit {

    @Input() key: any;
    content: any;
    constructor(public lang: LangService) {}
    ngOnInit() { this.content = this.lang.data[this.key]; }
}
